import React, { memo } from 'react';
import { Box, Container, Text, Link, Stack, Flex, Icon } from '@chakra-ui/react';
import { Linkedin, Mail } from 'lucide-react';
export const Footer = memo(function Footer() {
  const socialLinks = [{
    icon: Linkedin,
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/martin-randula/'
  }, {
    icon: Mail,
    label: 'Email',
    href: 'mailto:randula.martin@gmail.com'
  }];
  return <Box as="footer" bg="gray.800" color="white" py={8} role="contentinfo" data-id="element-64">
      <Container maxW="container.xl" data-id="element-65">
        <Stack spacing={6} align="center" data-id="element-66">
          <Flex gap={6} as="nav" aria-label="Social media links" data-id="element-67">
            {socialLinks.map(link => <Link key={link.label} href={link.href} isExternal={link.label !== 'Email'} _hover={{
            color: 'blue.300'
          }} transition="color 0.2s" aria-label={link.label} data-id="element-68">
                <Icon as={link.icon} boxSize={6} aria-hidden="true" data-id="element-69" />
              </Link>)}
          </Flex>
          <Text fontSize="md" data-id="element-70">Made by Martin Randula</Text>
          <Text fontSize="sm" color="gray.300" textAlign="center" data-id="element-71">
            Just sharing what I use. Some links are referral links that give me
            credits in these tools.
          </Text>
          <Text fontSize="xs" color="gray.400" data-id="element-72">
            © {new Date().getFullYear()} Martin's AI Kit
          </Text>
        </Stack>
      </Container>
    </Box>;
});